import { FC } from "react";
import { DIVIDED_STYLES, GROUP_STYLES, SUB_HEADER_STYLES } from "./styles";

type FieldsProps = {
  title?: string;
  addWrapperStyle?: boolean;
  additionalComponent?: JSX.Element | undefined;
};

export const Fields: FC<React.PropsWithChildren<FieldsProps>> = ({
  title,
  addWrapperStyle = true,
  children,
}) => {
  return (
    <div>
      {title && (
        <div className="flex items-center justify-between mb-4">
          <h3 className={SUB_HEADER_STYLES}>{title}</h3>
        </div>
      )}
      <div className={addWrapperStyle ? GROUP_STYLES : ""}>
        <div className={addWrapperStyle ? DIVIDED_STYLES : ""}>{children}</div>
      </div>
    </div>
  );
};
